import { useState, useCallback } from 'react'
import { GraphQLCampaignRepository } from '../../../infrastructure/graphql/CampaignRepositoryImpl'
import { useAuth0 } from '@auth0/auth0-react'
import { CampaignInput } from '../../../domain/entities/Campaign'

export function useCreateCampaign() {
  const { getIdTokenClaims } = useAuth0()

  const [creating, setCreating] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const createCampaign = useCallback(
    async (input: CampaignInput) => {
      setCreating(true)
      setError(null)
      let campaignId = ''
      try {
        const getToken = async () => (await getIdTokenClaims())?.__raw ?? ''
        const repo = new GraphQLCampaignRepository(getToken)
        campaignId = await repo.create(input)
      } catch (err: any) {
        setError(err)
        throw err
      } finally {
        setCreating(false)
        return campaignId
      }
    },
    [getIdTokenClaims]
  )

  return { createCampaign, creating, error }
}
